import { useEffect, useState } from "react";
import { HiPencil } from "react-icons/hi";
import { MdDelete } from "react-icons/md";
import LoadTable from "../../../LoadTable/LoadTable";
import "./InvoiceAndItemTable.scss";
import { RiErrorWarningFill } from "react-icons/ri";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";

const InvoiceAndItemTable = ({ data, Form_Key, handleDeleteMaterial, handleEditMaterial, tableName = "" }) => {
  const [toggle, settoggle] = useState(false);
  const [index, setIndex] = useState("");
  const [tableData, setTableData] = useState(data);
  const handleEdit = (i) => {
    handleEditMaterial(i);
  };
  const handleDelete = (i) => {
    setIndex(i);
    settoggle(true);
  };
  useEffect(() => {
    let updatedData = data?.map((el, i) => {
      let newObj = { ...el };
      let Action = (
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <HiPencil className="icon_styling" onClick={() => handleEdit(i)} />
          |
          <MdDelete onClick={() => handleDelete(i)} />
        </div>
      );
      delete newObj.__typename;

      if (newObj?.Packaging_Data) {
        newObj.Packaging = newObj?.Packaging_Data?.Type_Of_Packaging
        delete newObj.Packaging_Data
      }
      if (newObj?.Part_Data) {
        delete newObj.Part_Data
      }
      if (Form_Key === "Consignment_Note" || Form_Key === "FTL_Consignment_Note") {
        return { ...newObj };
      } else {
        return { Action: Action, ...newObj };
      }
    });
    setTableData(updatedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);


  return (
    <>
      {toggle && (
        <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"} id={""}>
          <div className="warning">
            <RiErrorWarningFill className="warningIcon" />
            <p className="warningMsg">Are You Sure You Want to Delete this Item?</p>
          </div>

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={() => {
              handleDeleteMaterial(index);
              settoggle(false);
            }}
            submitType={"Confirm Delete"}
            handleformclose={() => {
              settoggle(!toggle);
            }}
            loadingState={false}
          />
        </Reactportal>
      )}
      {tableData && tableData.length > 0 ? (
        <div style={{ width: "100%" }} className="Load-table-hide-header">
          <LoadTable
            title="LRTable"
            data={tableData}
            loading={false}
            error={false}
            SelectCheckbox={false}
            colAddition={["Invoice_Value", ""]}
          />
        </div>
      ) : (
        <div className="LoadReceiptTable">
          {Form_Key === "Consignment_Note" || Form_Key === "FTL_Consignment_Note"
            ? `${tableName} Data not avalible`
            : `${Form_Key} Data not avalible`}{" "}
        </div>
      )}
    </>
  );
};

export default InvoiceAndItemTable;
